import { Component, inject, OnInit, ViewChild } from '@angular/core';
import {
  BackendDataSourceService,
  BusinessItem,
  FilterView,
  FilterViewProviderDirective,
  ItemView,
  ItemViewProviderDirective,
  ListView,
  ListViewProviderDirective,
  NtapCommonComponent
} from '@ntap/core';
import { MessageService } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { first, map, mergeMap, Observable, tap } from 'rxjs';
import { AuthService } from '../login.component/service/auth.service';
import { PretragaKatalogaProviderDirective } from '../pretraga-kataloga/providers/pretraga-kataloga.provider';

@Component({
  selector: 'app-odabir-pretrage',
  templateUrl: './odabir-pretrage.component.html',
  styleUrls: ['./odabir-pretrage.component.scss'],
  providers: [BackendDataSourceService, PretragaKatalogaProviderDirective]
})
export class OdabirPretrageComponent
  extends NtapCommonComponent
  implements OnInit
{
  constructor(
    protected itemViewProvider: ItemViewProviderDirective<ItemView>,
    protected listViewProvider: ListViewProviderDirective<ListView>,
    protected filterViewProvider: FilterViewProviderDirective<FilterView>,
    protected backendDataSource: BackendDataSourceService,
    protected pretragaKatalogaService: PretragaKatalogaProviderDirective,
    protected messageService: MessageService
  ) {
    super();
  }

  odabranaSpremljenaPretraga: any;
  isNewSearchvalid = false;
  savedSearches: any[];
  filterState: object;
  searchExists = false;
  currentViewName: string = this.listViewProvider.viewName;
  currentUserId: number;
  hasNoFilter$: Observable<boolean>;
  buttonDisabled = true;
  nazivPretrage = null;

  @ViewChild(OverlayPanel)
  overlayPanel: OverlayPanel;

  private authService = inject(AuthService);

  handleApplySearch() {
    if (
      this.odabranaSpremljenaPretraga['earhiv~predlozak_pretrage~filter_state']
    ) {
      const filterStateFromSavedSearch = JSON.parse(
        this.odabranaSpremljenaPretraga[
          'earhiv~predlozak_pretrage~filter_state'
        ]
      );
      this.filterViewProvider.runSearch(filterStateFromSavedSearch);
      return;
    }
    this.listViewProvider.viewState = {};
  }

  handleSaveSearch() {
    const viewStateFromListViewProvider: any = this.listViewProvider.viewState;
    const filterWithoutNullData: any = {};

    for (const key in viewStateFromListViewProvider) {
      const attributeIsNotNull = viewStateFromListViewProvider[key] !== null;
      const attributeIsNotEmptyArray = !(
        viewStateFromListViewProvider[key] instanceof Array &&
        viewStateFromListViewProvider[key].length === 0
      );

      if (attributeIsNotNull && attributeIsNotEmptyArray) {
        filterWithoutNullData[key] = viewStateFromListViewProvider[key];
      }
    }

    this.filterState = filterWithoutNullData;

    const newSearchData = {
      'earhiv~predlozak_pretrage~id':
        (this.odabranaSpremljenaPretraga &&
          this.odabranaSpremljenaPretraga['earhiv~predlozak_pretrage~id']) ||
        0,
      'earhiv~predlozak_pretrage~vstamp':
        (this.odabranaSpremljenaPretraga &&
          this.odabranaSpremljenaPretraga[
            'earhiv~predlozak_pretrage~vstamp'
          ]) ||
        1,
      'earhiv~predlozak_pretrage~owner_id': this.currentUserId,
      'earhiv.predlozak_pretrage.naziv':
        this.nazivPretrage ||
        this.odabranaSpremljenaPretraga['earhiv~predlozak_pretrage~naziv'],
      'earhiv.predlozak_pretrage.filter_state': JSON.stringify(
        this.filterState
      ),
      $mainType: 'earhiv.predlozak_pretrage',
      'earhiv.predlozak_pretrage.ui_view_name': this.currentViewName,
      $itemType: 'earhiv.predlozak_pretrage'
    };

    const businessItem: BusinessItem = new BusinessItem(newSearchData);

    this.backendDataSource
      .saveViewData('predlosci_pretrage', businessItem)
      .subscribe(() => this.generateSavedSearchesData());

    this.messageService.add({
      severity: 'success',
      summary: 'Predložak spremljen',
      detail: `Predložak pretrage: "${newSearchData['earhiv.predlozak_pretrage.naziv']}" spremljen`
    });

    this.overlayPanel.hide();
    this.nazivPretrage = null;
  }

  verifyIfSearchExists() {
    if (this.odabranaSpremljenaPretraga) {
      for (let i = 0; i < this.savedSearches.length; i++) {
        const selectedSearchObjectNameExists =
          this.savedSearches[i]['earhiv~predlozak_pretrage~naziv'] ===
          this.odabranaSpremljenaPretraga['earhiv~predlozak_pretrage~naziv'];
        const selectedSearchValueNameExists =
          this.savedSearches[i]['earhiv~predlozak_pretrage~naziv'] ===
          this.odabranaSpremljenaPretraga;

        if (selectedSearchObjectNameExists || selectedSearchValueNameExists) {
          this.odabranaSpremljenaPretraga = this.savedSearches[i];
          this.searchExists = true;
          return;
        }

        this.searchExists = false;
      }

      this.isNewSearchvalid =
        Object.keys(this.listViewProvider.viewState).length > 0;
      return;
    }

    this.searchExists = false;
  }

  handleClearListViewState() {
    this.listViewProvider.viewState = {};
  }

  generateSavedSearchesData() {
    this.authService.validUser$
      .pipe(
        first(),
        mergeMap((user) => {
          this.currentUserId = user.userId.value;
          return this.backendDataSource
            .getViewData('predlosci_pretrage', {
              'earhiv~predlozak_pretrage~ui_view_name': this.currentViewName,
              'earhiv~predlozak_pretrage~owner_id': user.userId.value
            })
            .pipe(
              tap((data) => {
                this.savedSearches = data;
                const filtered = data.filter(
                  (d: any) =>
                    d['earhiv~predlozak_pretrage~id'] ===
                    (this.odabranaSpremljenaPretraga &&
                      this.odabranaSpremljenaPretraga[
                        'earhiv~predlozak_pretrage~id'
                      ])
                );
                if (filtered.length > 0) {
                  this.odabranaSpremljenaPretraga = filtered[0];
                } else {
                  this.odabranaSpremljenaPretraga = null;
                }
              })
            );
        })
      )
      .subscribe(() => this.verifyIfSearchExists());
  }

  ngOnInit() {
    this.generateSavedSearchesData();
    this.addSubscription(
      this.listViewProvider.viewData$
        .pipe(
          map(() => {
            this.buttonDisabled =
              Object.keys(this.listViewProvider.viewState).length <= 1;
            return;
          })
        )
        .subscribe()
    );
  }

  searchSelected() {
    this.buttonDisabled = false;
  }

  togglePanel(event: Event) {
    if (this.odabranaSpremljenaPretraga) {
      this.handleSaveSearch(); // spremljena, ne treba toggle, odmah spremamo
      this.nazivPretrage = null;
    } else {
      this.overlayPanel.toggle(event); // nije spremljena pa pokazujemo input box za naziv
    }
  }

  deleteSearch() {
    const index = this.savedSearches.findIndex(
      (c) => c == this.odabranaSpremljenaPretraga
    );
    this.listViewProvider
      .deleteItemAtIndex(
        new BusinessItem(this.odabranaSpremljenaPretraga),
        index
      )
      .subscribe(() => {
        this.generateSavedSearchesData();
        this.buttonDisabled = true;
      });
  }
}
